//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PaginationVue',
  props: {
    pagination: {}
  },
  created: function created() {},
  computed: {
    getTotalPages: function getTotalPages() {
      return this.pagination.total ? Math.ceil(this.pagination.total / this.pagination.limit) : 0;
    }
  },
  methods: {
    onInput: function onInput() {
      this.$emit('onInput', this.pagination.current);
    },
    goFirst: function goFirst() {
      this.pagination.current = 1;
      this.emitChange();
    },
    goNext: function goNext() {
      this.pagination.current++;
      this.emitChange();
    },
    goPrev: function goPrev() {
      this.pagination.current--;
      this.emitChange();
    },
    emitChange: function emitChange() {
      this.$emit('changePagina', this.pagination.current);
    },
    getTotalPage: function getTotalPage() {
      return Math.ceil(this.pagination.total / this.pagination.limit);
    }
  }
};